import { Badge, Card, Button } from "react-bootstrap";
import { DeleteButton } from "../../../components/DeleteButton/DeleteButton";
import { DisplayItem } from "../../../components/DisplayItem/DisplayItem";
import { EditButton } from "../../../components/EditButton/EditButton";
import { strings } from "../../../config/string";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloud, faBuilding, faProjectDiagram,  } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Folder } from "types";
import  { useState } from 'react';

type Props = {
  folder: Folder;
  onClickEdit: () => void;
  onClickDelete: () => void;

  onFilterByOffice?: (officeId: string) => void;
};

export const FolderItem = ({ folder, onClickEdit, onClickDelete, onFilterByOffice }: Props) => {
  const navigate = useNavigate();
  const [isOfficeHovered, setIsOfficeHovered] = useState(false);

  const handleOfficeClick = () => {
    if (onFilterByOffice && folder.officeId) {
      onFilterByOffice(folder.officeId);
    } else if (folder.officeId) {
      // Fallback or alternative behavior if needed, e.g., navigate
      // navigate(`/offices/${folder.officeId}`);
    }
  };

  const navigateToProjects = () => {
    navigate(`/folders/${folder.id}?view=projects`);
  };

  return (
    <DisplayItem>
      <Card.Body>
        <Card.Title>{folder.name}</Card.Title>
        <Card.Text>
          {folder.officeId && folder.officeName && (
            <Badge 
              className="bg-primary border-dark text-white p-2 opacity-100 me-2"
              onClick={handleOfficeClick}
              style={{
                cursor: onFilterByOffice ? 'pointer' : 'default',
                transition: 'filter 0.2s ease-in-out',
                filter: isOfficeHovered ? 'brightness(1.15)' : 'none'
              }}
              title={onFilterByOffice ? `Filter by Office: ${folder.officeName}` : folder.officeName}
              onMouseEnter={() => onFilterByOffice && setIsOfficeHovered(true)}
              onMouseLeave={() => setIsOfficeHovered(false)}
            >
              <FontAwesomeIcon icon={faBuilding} className="me-1" />
              {folder.officeName}
            </Badge>
          )}
          {folder.foreignId && (
            <Badge className="border-dark text-white p-2 opacity-100 shadow bg-info rounded">
              <FontAwesomeIcon icon={faCloud} className="me-1" style={{ color: '#FFD700' }} />
              NCVIB-ID: {folder.foreignId}
            </Badge>
          )}
        </Card.Text>
      </Card.Body>
      <Card.Footer className="pt-0">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <EditButton onClick={onClickEdit} />
            <DeleteButton onClick={onClickDelete} />
          </div>
          <div>
            <Button
              className="btn-sm"
              variant="primary"
              onClick={navigateToProjects}
            >
              <FontAwesomeIcon icon={faProjectDiagram} className="me-1" />
              {strings.showProjects}
            </Button>
          </div>
        </div>
      </Card.Footer>
    </DisplayItem>
  );
};
